/**
 * roc-feather - version 7.7.1
 * last update: 01-23-2018 6:21:34 AM UTC
 * Copyright 2018 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */

define('modules/Checkout/FreightCollect',[
    'jquery',
    'global/all',
], function ($, Roc) {
    'use strict';

    var forms = {
        recipientFreightCollectData: {
            Fields: [
                {
                    "Name": 'Carrier',
                    "Field": '#carrier-{id}',
                    "Param": 'carrier',
                    "Type": 'Text',
                    "Optional": false
                },
                {
                    "Name": 'Carrier Acct Number',
                    "Field": '#carrier-acct-number-{id}',
                    "Param": 'carrierAcctNumber',
                    "Type": 'Text',
                    "Optional": false
                }, 
                {
                    "Name": 'Shipping Instructions',
                    "Field": '#shipping-instructions-{id}',
                    "Param": 'shippingInstructions',
                    "Type": 'Text',
                    "Optional": true
                }
            ],
            Validate: true,
            RequestParam: 'freightCollectData'
        }
    };

    function getRecipientContainerByElement(target) {
        return $(target).closest('div.panel-primary[data-recipient-id]');
    }

    function getRecipientId(target) {
        var $recipientContainer = getRecipientContainerByElement(target);
        return $recipientContainer.attr('data-recipient-id');
    }

    function updateFreightCollectInformationsEvt() {
        $(document).on('focusout', '.freight-collect-information', function () {
            var form = forms.recipientFreightCollectData;
            var recipientId = getRecipientId(this);

            $.each(form.Fields, function (index, field) {
                field.Field = field.Field.replace('{id}', recipientId);
            });

            var request = {
                recipientId: recipientId
            };

            var data = Roc.Forms.getFormValues(form);
            request = $.extend({}, request, data);

            $.proxyRequest({
                url: '/api/shipping/freight/updateinformation',
                data: JSON.stringify(request),
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json',
                complete: function (xhr) {
                }
            });
        });
    }

    function buildRecipientViewModel(recipient, isLoggedIn) {
        recipient.canCaveCarrier = isLoggedIn;
    }

    function bindEvents() {
        updateFreightCollectInformationsEvt();
    }

    function init() {
        bindEvents();
    }

    var FreightCollect = {
        init: init,
        forms: forms,
        buildRecipientViewModel: buildRecipientViewModel
    };

    Roc.Logger.debug('FreightCollect.js Loaded:', FreightCollect);

    return FreightCollect;
});
